export default __webpack_public_path__ + "static/media/icon_skill_shield_blue.2e158ee1.png";